import React, { Component } from 'react';

class SpiceItemComponent extends Component {
    render() {
        const desc = this.props.description;
        let descriptionTag;
        if (desc)
            descriptionTag = <p>{desc}</p>
        return (
            <div className="container">
                <h1>{this.props.title}</h1>
                {descriptionTag}
            </div>
        );
    }
}

export default SpiceItemComponent;



// WEBPACK FOOTER //
// ./src/components/spice/spice.item.component.jsx